import { CustomWidgetTypes } from "../../types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum FILTER_TYPE {
    SELECT_TYPE_MULTISELECT = "SELECT_TYPE_MULTISELECT",
    SELECT_TYPE_SINGLESELECT = "SELECT_TYPE_SINGLESELECT",
}

export interface ISortConfigs {
    key: string;
    title: string;
    selected?: boolean;
    defaultSelection?: boolean;
}
export interface ISortConfigsTransform {
    value: string;
    label: string;
    selected?: boolean;
    defaultSelection?: boolean;
}

export type IAnalytics = object;
export interface IFacetInfo {
    label: string;
    id: string; // childId
    analytics?: IAnalytics;
    selected?: boolean;
    openFilter?: boolean;
    icon?: string;
}
export interface IFacetInfoTransform {
    label: string;
    value: string;
    analytics?: IAnalytics;
    selected?: boolean;
    openFilter?: boolean;
}
export interface IRefineList extends IFacetInfo {
    parentId: string;
}
export interface IFacetList {
    label: string;
    id: string; // parentId
    selection: string;
    facetInfo: IFacetInfo[];
    viewType: string;
    subLabel?: string;
    canSearch?: boolean;
    openFilter?: boolean;
    icon?: string;
    selectedIcon?: string;
    toolTipText?: string;
}
export interface IData {
    "@type": CustomWidgetTypes.REFINE_WIDGET;
    id?: string;
    sortConfigs: ISortConfigs[];
    restaurantCount: number;
    facetList: IFacetList[];
}
export interface IFilterContent {
    filter: IFacetList;
    updateFilterList: (value: string[], id: string) => void;
    selectedFilters: string[];
}
export interface IHalfCardExtraParams {
    selectedFacet?: IFacetInfo[];
    facetInfo?: IFacetList;
}
export interface IHalfCardContent {
    sortList: ISortConfigs[];
    filterList: IFacetList[];
    onApply: (
        selectedFilters: Record<string, string[]>,
        extraParams?: IHalfCardExtraParams
    ) => void;
    onClearFilters?: VoidFunction;
}
export interface ISortContent {
    sortList: ISortConfigs[];
    updateFilterList: (value: string[], id: string) => void;
    selectedFilters: string[];
}
export type IApplyHandler = (
    selectedFilters: Record<string, string[] | IQueryInfo[]>,
    onClose?: VoidFunction
) => void;
export interface IRefineWidget {
    "@type": CustomWidgetTypes.REFINE_WIDGET;
    id?: string;
    sortConfigs: ISortConfigs[];
    restaurantCount: number;
    facetList: IFacetList[];
}
export interface IQueryInfo {
    label: string;
    id: string;
    operator: string;
}
export interface IFacetInfoDish extends IFacetInfo {
    description: string;
    operator: string;
}
export interface IFacet {
    label: string;
    id: string;
    selection: FILTER_TYPE;
    hidden: boolean;
    facetInfo: IFacetInfoDish[];
}
